/**
 * Get the value of a cookie.
 *
 * @param key The key (name) of the cookie.
 * @returns {*} The value of the cookie or undefined if no cookie could be found.
 */
export const hjGetCookie = (key: string): string | null => {
  const result = new RegExp(`(?:^|; )${key}=([^;]*)`).exec(document.cookie);
  return result ? result[1] : null;
};

/**
 * Set the value of a cookie.
 *
 * @param key The key (name) of the cookie.
 * @param value The value of the cookie.
 * @param expiresDays The number of days until the cookie should expire.
 * @param domain The domain to set the cookie on.
 */
// FIXME: Please fix this. You may refer to CFE-266 for more details.
// eslint-disable-next-line func-params-args/func-params
export const hjSetCookie = (
  key: string,
  value: string,
  // eslint-disable-next-line @typescript-eslint/default-param-last
  expiresDays = 365,
  domain: string,
): void => {
  const expiresTime = new Date();

  expiresTime.setTime(expiresTime.getTime() + expiresDays * 24 * 60 * 60 * 1000);
  document.cookie = `${key}=${value}; path=/; expires=${expiresTime.toUTCString()}; ${
    domain && `domain=${domain};`
  }`;
};

export const hjCookieConverter = {
  decode(value: string): string {
    return decodeURIComponent(value);
  },
  encode(value: unknown): string {
    const stringifiedValue = typeof value === 'object' ? JSON.stringify(value) : String(value);
    return encodeURIComponent(stringifiedValue);
  },
};
